
<new-participant #newParticipant
                 [hidden]="!newParticipantPanelOpen"
                 [title]="'detailed_processing.participant.title.new_participant' | translate"
                 [idPrefix]="(idPrefix + 'new.')"
                 [(panelOpen)]="newParticipantPanelOpen"
                 [typeSelectOptions]="participantTypeSelectOptions"
                 [participantTypeUriBuilderParams]="participantTypeUriBuilderParams"
                 (create)="create($event)">
</new-participant>

<div class="row no-gutters" *ngIf="!newParticipantPanelOpen">
    <div class="col-12 text-right">
        <a id="{{idPrefix}}btn.add"
           mat-stroked-button
           color="accent"
           class="add-btn"
           (click)="newParticipantPanelOpen = true">
            {{ 'workflow_management.btn.add_default_participants' | translate }}
        </a>
    </div>
</div>

<mat-list class="full-width">
    <mat-list-item *ngFor="let participant of workflow?.defaults?.participants.items; let idx = index">

        <h3 matLine>{{ participant.displayName }}</h3>

        <button id="{{idPrefix}}participant_{{idx}}.btn.delete"
                mat-icon-button
                (click)="delete(participant)"
                [disabled]="disabled">
            <mat-icon class="dr-material-icon"
                      [ngClass]="{ 'disabled': disabled }"
                      matTooltip="{{ 'common.label.delete' | translate }}">clear
            </mat-icon>
        </button>
    </mat-list-item>
</mat-list>
